import { Link } from 'react-router-dom';

const BASE_URL = 'https://roameurope.blog';

export interface BreadcrumbItem {
  name: string;
  path: string; // relative path, e.g. "/" or "/category/dating"
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}

/**
 * Renders both:
 * 1. A Schema.org BreadcrumbList JSON-LD <script> tag for Google rich results
 * 2. A visible accessible breadcrumb nav for users
 */
export default function BreadcrumbSchema({ items }: BreadcrumbSchemaProps) {
  const schemaJson = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${BASE_URL}${item.path}`,
    })),
  });

  const isLast = (index: number) => index === items.length - 1;

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: schemaJson }}
      />
      <nav aria-label="Breadcrumb" className="flex items-center flex-wrap gap-1 text-xs text-stone-400 dark:text-stone-500">
        {items.map((item, index) => (
          <span key={item.path} className="flex items-center gap-1">
            {isLast(index) ? (
              <span
                className="text-stone-500 dark:text-stone-400 font-medium truncate max-w-[220px]"
                aria-current="page"
              >
                {item.name}
              </span>
            ) : (
              <Link
                to={item.path}
                className="hover:text-rose-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.name}
              </Link>
            )}
            {!isLast(index) && (
              <i className="ri-arrow-right-s-line text-stone-300 dark:text-stone-600" />
            )}
          </span>
        ))}
      </nav>
    </>
  );
}
